import { render } from "./ArchaicReferences.vue?vue&type=template&id=52390a70"
import script from "./ArchaicReferences.vue?vue&type=script&lang=js"
export * from "./ArchaicReferences.vue?vue&type=script&lang=js"

import "./ArchaicReferences.vue?vue&type=style&index=0&id=52390a70&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__